import { z } from "zod";

export const ZGulvMotTemperertArealSchema = z.object({
  // 9
  isActive: z.boolean().default(false),
  tekst: z.string(),
  isolasjonOver: z.object({
    // 9.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  isolasjonUnder: z.object({
    // 9.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
});

export type IGulvMotTemperertArealSchema = z.infer<typeof ZGulvMotTemperertArealSchema>;
